import { Box, Button } from "@mui/material";
import { type ReactElement, useState } from "react";
import { useHistory } from "react-router-dom";

import { AnimatedBackgroundPageWrapper } from "../layouts/AnimatedBackgroundPageWrapper";
import { waitForSession } from "../utils/waitForSession";
import { loginWithEmailAndPassword } from "./loginWithEmailAndPassword";
import { MobileLoginWithEmailAndPasswordForm } from "./MobileLoginWithEmailAndPasswordForm";

export function MobileLoginWithEmailAndPassword(): ReactElement {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const handleSubmit = async () => {
    if (!email || !password) {
      return;
    }

    setLoading(true);

    const success = await loginWithEmailAndPassword({
      email,
      password,
    });

    // After successful login, wait for Redux to populate
    if (success) {
      try {
        // Wait for Redux session to initialize
        await waitForSession();

        setLoading(false);
        history.replace("/mobile/calendar");
      } catch {
        // waitForSession shows error toast internally
        setLoading(false);
      }

      return;
    }

    setLoading(false);
  };

  const handleBackClick = () => {
    history.push("/mobile/login");
  };

  return (
    <AnimatedBackgroundPageWrapper>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          padding: 3,
          paddingTop: "max(24px, env(safe-area-inset-top))",
          paddingBottom: "max(24px, env(safe-area-inset-bottom))",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Logo */}
        <Box
          sx={{
            marginBottom: 4,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img
            src={`${process.env.REACT_APP_BASE_PATH ?? "/"}brownAndRedBunny.png`}
            alt="Clipboard Health"
            style={{ height: 150, width: "auto" }}
          />
        </Box>

        {/* Content */}
        <Box
          sx={{
            width: "100%",
            maxWidth: 400,
          }}
        >
          <MobileLoginWithEmailAndPasswordForm
            email={email}
            password={password}
            loading={loading}
            setEmail={setEmail}
            setPassword={setPassword}
            onSubmit={handleSubmit}
          />

          {/* Back to magic link login */}
          <Box sx={{ textAlign: "center", marginTop: 3 }}>
            <Button
              variant="text"
              sx={{
                textTransform: "none",
                fontSize: "0.9rem",
              }}
              onClick={handleBackClick}
            >
              ← Back to magic link login
            </Button>
          </Box>
        </Box>
      </Box>
    </AnimatedBackgroundPageWrapper>
  );
}
